const DocumentIcon = ({ size = 24, color = 'currentColor', className = '' }) => (
  <svg aria-hidden="true"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    className={className}
  >
    <path d="M6 2h9l5 5v15H6z" />
    <path d="M14 2v6h6" />
  </svg>
);

export default DocumentIcon;
